import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-spinner-card',
  templateUrl: './spinner-card.component.html'
})
export class SpinnerCardComponent implements OnDestroy, OnChanges, OnInit {
  
  ngOnInit(): void {
    if (this.showInitialValue === true){
      this.showSpinner();
    }

    if (this.timeToHide > 0) {
      setTimeout(() => {
        this.hideSpinner();
      }, this.timeToHide);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.listenObservable();
  }

  ngOnDestroy(): void {
    if (this.loading$) {
      this.loading$.unsubscribe();
    }
  }

  @Input() timeToHide: number = 60000;
  @Input() show: boolean = false;
  @Input() showInitialValue: boolean = false;
  @Input() observable: Observable<boolean>;
  loading$: Subscription;

  showSpinner() {
    this.show = true;
  }

  hideSpinner() {
    this.show = false;
  }

  listenObservable() {
    if (this.observable && !this.loading$) {
      this.showSpinner();
      this.loading$ = this.observable.subscribe(
        null, (err) => {this.hideSpinner();}, () => {this.hideSpinner();}
      );
    }
  }
}
